import React, { useState, useEffect, useContext } from 'react';
import { FaBox, FaCheckCircle, FaClock, FaArchive, FaChartLine, FaDollarSign } from 'react-icons/fa';
import AppContext from '../../../context/AppContext';
import axios from 'axios';

const PackageDashboard = () => {
    const { baseUrl, authToken } = useContext(AppContext);
    const [stats, setStats] = useState({
        total: 0,
        active: 0,
        draft: 0,
        archived: 0,
        totalBookings: 0,
        totalRevenue: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = () => {
        axios.get(`${baseUrl}/admin/travel-packages-get`, {
            headers: { "Authorization": `Bearer ${authToken}` }
        })
        .then((response) => {
            if (response.data.success) {
                const packages = response.data.data;
                setStats({
                    total: packages.length,
                    active: packages.filter(p => p.package_status === 'published' && p.is_available).length,
                    draft: packages.filter(p => p.package_status === 'draft').length,
                    archived: packages.filter(p => p.package_status === 'archived').length,
                    totalBookings: 0,
                    totalRevenue: 0
                });
            }
            setLoading(false);
        })
        .catch((error) => {
            console.error('Error fetching dashboard data:', error);
            setLoading(false);
        });
    };

    const statsCards = [
        { id: 1, title: 'Total Packages', value: stats.total, icon: FaBox, color: '#2C5F7C', bgColor: '#E8F4F8' },
        { id: 2, title: 'Active Packages', value: stats.active, icon: FaCheckCircle, color: '#28A745', bgColor: '#E8F8EA' },
        { id: 3, title: 'Draft Packages', value: stats.draft, icon: FaClock, color: '#FFB800', bgColor: '#FFF8E1' },
        { id: 4, title: 'Archived Packages', value: stats.archived, icon: FaArchive, color: '#DC3545', bgColor: '#FCE8EA' },
        { id: 5, title: 'Total Bookings', value: stats.totalBookings, icon: FaChartLine, color: '#17A2B8', bgColor: '#E6F7F9' },
        { id: 6, title: 'Total Revenue', value: `PKR ${stats.totalRevenue.toLocaleString()}`, icon: FaDollarSign, color: '#4A9E8E', bgColor: '#E8F6F3' }
    ];

    if (loading) {
        return (
            <div className="adm-pkg-loading-state">
                <div className="adm-pkg-spinner"></div>
                <p>Loading dashboard...</p>
            </div>
        );
    }

    return (
        <div className="adm-pkg-dashboard">
            <div className="adm-pkg-stats-grid">
                {statsCards.map(card => {
                    const IconComponent = card.icon;
                    return (
                        <div key={card.id} className="adm-pkg-stat-card">
                            <div className="adm-pkg-stat-icon" style={{ backgroundColor: card.bgColor }}>
                                <IconComponent style={{ color: card.color, fontSize: '24px' }} />
                            </div>
                            <div className="adm-pkg-stat-content">
                                <h3 className="adm-pkg-stat-value">{card.value}</h3>
                                <p className="adm-pkg-stat-title">{card.title}</p>
                            </div>
                        </div>
                    );
                })}
            </div>

            
            </div>

    );
};

export default PackageDashboard;